import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/audio/item-obtain.ogg'
import _imports_1 from '@/assets/audio/item-obtain.mp3'
import _imports_2 from '@/assets/audio/close-overlay.ogg'
import _imports_3 from '@/assets/audio/close-overlay.mp3'
import _imports_4 from '@/assets/images/star.svg'


const _withScopeId = n => (_pushScopeId("data-v-59966cc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("audio", { autoplay: "" }, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "audio/ogg"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_1,
    type: "audio/mp3"
  })
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ] ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_2,
  type: "audio/ogg"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_3,
  type: "audio/mp3"
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "obtained" }, "Obtained", -1))
const _hoisted_7 = {
  id: "item-obtain-overlay-center-box",
  class: "center-box"
}
const _hoisted_8 = { class: "description" }
const _hoisted_9 = {
  id: "item-obtain-overlay-items-box",
  class: "items-box"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "star-box" }
const _hoisted_13 = { class: "quantity-text" }
const _hoisted_14 = { class: "item-name" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dim" }, "Press anywhere in the blank area to continue", -1))

import { ItemStringQuantity } from "@/types";
import { ItemDatabase } from "@/state/Gacha";
import { computed, ref, Ref } from "vue";
import ItemDescriptionOverlay from "./ItemDescriptionOverlay.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    obtainedItems: null,
    description: null
  },
  emits: ["exit"],
  setup(__props: any, { emit }) {

const props = __props as {
  obtainedItems: ItemStringQuantity[];
  description?: string;
}



const activeItemId = ref("");
const active = ref(true);
const audioExitOverlay: Ref<HTMLAudioElement | null> = ref(null);

const items = computed(() =>
  props.obtainedItems
    .map((i) => {
      return {
        item: ItemDatabase[i.id],
        quantity: i.quantity,
      };
    })
    .filter((i) => i.quantity > 0)
);
const activeItem = computed(() => ItemDatabase[activeItemId.value]);

const exitOutsideCheck = (e: Event) => {
  if (
    e.target === document.getElementById("item-obtain-overlay-bg") ||
    e.target === document.getElementById("item-obtain-overlay-center-box")
  ) {
    active.value = false;
    audioExitOverlay.value?.play();
  }
};
const exit = () => {
  if (!active.value) emit("exit");
};

return (_ctx: any,_cache: any) => {
  const _directive_dragscroll = _resolveDirective("dragscroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("audio", {
      ref_key: "audioExitOverlay",
      ref: audioExitOverlay,
      preload: "auto"
    }, _hoisted_5, 512),
    (_unref(activeItem))
      ? (_openBlock(), _createBlock(ItemDescriptionOverlay, {
          key: 0,
          item: _unref(activeItem),
          onExit: _cache[0] || (_cache[0] = ($event: any) => (activeItemId.value = ''))
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "zoom-fade",
      onAfterLeave: exit
    }, {
      default: _withCtx(() => [
        (active.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "item-obtain-overlay-bg",
              class: "main",
              onClick: exitOutsideCheck
            }, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(__props.description), 1),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (i, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "box-for-one-item"
                    }, [
                      _createElementVNode("div", {
                        class: "item-box-graphics",
                        onClick: ($event: any) => (activeItemId.value = i.item.id)
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass([
                  [0, 'gray', 'green', 'blue', 'purple', 'orange'][
                    i.item.rarity
                  ],
                  'item-pic-box',
                ])
                        }, [
                          _createElementVNode("img", {
                            src: require(`@/assets/images/${i.item.id}.webp`),
                            class: "icon-img"
                          }, null, 8, _hoisted_11)
                        ], 2),
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.item.rarity, (ind) => {
                            return (_openBlock(), _createElementBlock("img", {
                              key: ind,
                              class: "star-img",
                              src: _imports_4
                            }))
                          }), 128))
                        ]),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(i.quantity), 1)
                      ], 8, _hoisted_10),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(i.item.name), 1)
                    ]))
                  }), 128))
                ])), [
                  [
                    _directive_dragscroll,
                    void 0,
                    void 0,
                    { x: true }
                  ]
                ])
              ]),
              _hoisted_15
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})